import { React, useState } from "react";
import PricingHeader from "./PricingHeader";
import PricingCard from "./PricingCard";
import SubscriptionDialog from "../dialogs/SubscriptionDialog";
import plans from "../constants/PricingPlans";

export default function PricingPlans() {
  const [showSubscriptionDialog, setShowSubscriptionDialog] = useState(false);

  const handleSubscribeClick = () => {
    setShowSubscriptionDialog(true);
  };

  return (
    <>
      <PricingHeader />
      <div className="w-full px-2 pb-16 bg-white min-h-[70vh] flex flex-col justify-center items-center">
        <div className="max-w-sm mx-auto mt-2">
          {plans.map((plan) => (
            <PricingCard
              key={plan.type}
              plan={plan}
              isPopular={plan.highlight}
              onSubscribe={handleSubscribeClick}
            />
          ))}
        </div>
      </div>
      {showSubscriptionDialog && (
        <SubscriptionDialog onClose={() => setShowSubscriptionDialog(false)} />
      )}
    </>
  );
}
